import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import { useContext, useEffect, useState } from "react";
import { ToastContext } from "../contexts/ToastContext/ToastContext";

const containerStyle = {
  width: "100%",
  height: "400px",
};

const Map = ({ address }: { address: string }) => {
  const toast = useContext(ToastContext);
  const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: apiKey ?? "AIzaSyCbuD7xB5yIVAt3omHHoid3Rg3xxe3jvdc",
  });

  const [center, setCenter] = useState<{ lat: number; lng: number } | null>(null); // Initialize with null
  const [isFetching, setIsFetching] = useState(true); // Add loading state

  useEffect(() => {
    const fetchCoordinates = async () => {
      const encodedAddress = encodeURIComponent(address);
      const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${apiKey}`;
      try {
        const response = await fetch(url);
        const data = await response.json();
        if (data.status === "OK") {
          const location = data.results[0].geometry.location;
          setCenter({ lat: location.lat, lng: location.lng });
        } else {
          toast?.errorToast("Address not found");
        }
      } catch (error) {
        toast?.errorToast("Address not found");
      } finally {
        setIsFetching(false); // Set loading to false after fetching coordinates
      }
    };

    fetchCoordinates();
  }, [address, apiKey, toast]);

  return isLoaded && !isFetching && center ? (
    <>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={14} // Set default zoom level to 14
      >
        <Marker position={center} title={address} />
      </GoogleMap>
      <div className="flex justify-center">
        <a
          href={`https://maps.google.com?q=${center.lat},${center.lng}`}
          rel="noreferrer"
          target="_blank"
          className="text-docsigna-purple font-bold text-base mt-5">
          Open in Google Map
        </a>
      </div>
    </>
  ) : (
    <p>Loading map...</p> // Show loading message until the map is ready
  );
};

export default Map;
